import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getChatusers ,getChatMessages, sendChatMessage as sendChatMessageApi} from "../../Api/AdminApiCall";

export const fetchChatUsers = createAsyncThunk(
    "admin/fetchChatUsers",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getChatusers();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load chat users"
            );
        }
    }
);

export const fetchChatMessages = createAsyncThunk(
    "admin/fetchChatMessages",
    async (conversationId, { rejectWithValue }) => {
        try {
            const res = await getChatMessages(conversationId);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load chat messages"
            );
        }
    }
);

export const sendChatMessage = createAsyncThunk(
    "admin/sendChatMessage",
    async (data, { rejectWithValue }) => {
        try {
            const res = await sendChatMessageApi(data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to send chat message"
            );
        }
    }
);

const ChatSlice = createSlice({
    name: "ChatSlice",
    initialState: {
        chatUsers: [],
        chatMessages: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchChatUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchChatUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.chatUsers = action.payload;
            })
            .addCase(fetchChatUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchChatMessages.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchChatMessages.fulfilled, (state, action) => {
                state.loading = false;
                state.chatMessages = action.payload;
            })
            .addCase(fetchChatMessages.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(sendChatMessage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendChatMessage.fulfilled, (state, action) => {
                state.loading = false;
                // Optionally update chatMessages if API returns updated messages
                // Otherwise, we'll refetch messages after sending
            })
            .addCase(sendChatMessage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

const ChatSliceReducer = ChatSlice.reducer;

export default ChatSliceReducer;

